// extracted by mini-css-extract-plugin
export default {"box":"Cart_box__65wfn","content":"Cart_content__4sKMh"};